import script from "./question.vue?vue&type=script&setup=true&lang=ts"
export * from "./question.vue?vue&type=script&setup=true&lang=ts"

import "./question.vue?vue&type=style&index=0&id=751865d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751865d5"]])

export default __exports__